export const LoadNextPageTask = ({ listContext }) => {
    // TODO: Реалізувати завантаження наступної сторінки
}
